const EN = {
    title: 'Telephones',
    actions: 'Modify phone number',
    table: {
        title: 'Telephones',
        columns: {
            id: 'Id',
            telephone: 'Phone',
            created_at: 'Creation date',
            updated_at: 'Modification date',
            status: 'Status',
        },
        status: {
            3: 'Active',
            2: 'Inactive',
            title: 'Status'
        },
    },
    inputs: {
        modify: 'New phone number',
    },
    alert: {
        info: {
            title: 'We sent a message to ',
            description: 'The client has 24 hours to log in and complete the verification requested there'
        },
        warning: {
            title1: 'The phone ',
            title2: ' is not available to be used by this client',
            description: 'Please request another phone'
        }
    }

};

export default EN;
